import { loadStripe } from '@stripe/stripe-js';

let stripePromise;

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY);
  }
  return stripePromise;
};

// Updated to work with the new secure endpoint
export const createSubscription = async (paymentMethodId, priceId, couponCode = null) => {
  const userData = JSON.parse(localStorage.getItem('workos_user') || '{}');
  const accessToken = userData.accessToken;
  
  if (!accessToken) {
    throw new Error('Authentication required. Please sign in.');
  }
  
  if (!paymentMethodId?.startsWith('pm_')) {
    throw new Error('Invalid payment method ID');
  }

  const response = await fetch('/.netlify/functions/create-subscription', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
    body: JSON.stringify({ 
      paymentMethodId,
      priceId,
      couponCode,
      promotionCode: couponCode // Support both parameter names
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || error.message || 'Failed to create subscription');
  }

  return response.json();
};

export const validateCoupon = async (couponCode) => {
  const response = await fetch('/.netlify/functions/validate-coupon', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ couponCode }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Invalid coupon code');
  }

  return response.json();
};

export const getSubscription = async () => {
  const userData = JSON.parse(localStorage.getItem('workos_user') || '{}');
  const accessToken = userData.accessToken;
  
  if (!accessToken) {
    throw new Error('Authentication required');
  }

  const response = await fetch('/.netlify/functions/get-subscription', {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${accessToken}`
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to fetch subscription');
  }

  return response.json();
};

export const cancelSubscription = async (subscriptionId) => {
  const userData = JSON.parse(localStorage.getItem('workos_user') || '{}');
  const accessToken = userData.accessToken;
  
  if (!accessToken) {
    throw new Error('Authentication required');
  }

  const response = await fetch('/.netlify/functions/cancel-subscription', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
    body: JSON.stringify({ subscriptionId }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to cancel subscription');
  }

  return response.json();
};

export const reactivateSubscription = async (subscriptionId) => {
  const userData = JSON.parse(localStorage.getItem('workos_user') || '{}');
  const accessToken = userData.accessToken;

  if (!accessToken) {
    throw new Error('Authentication required');
  }

  const response = await fetch('/.netlify/functions/reactivate-subscription', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
    body: JSON.stringify({ subscriptionId }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to reactivate subscription');
  }

  return response.json();
};

export const createDonation = async (amount, email, name) => {
  const response = await fetch('/.netlify/functions/create-donation', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      amount, // amount in cents
      email,
      name
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to create donation');
  }

  return response.json();
};